import React from 'react';

export default function Map() {
  return (
    <div className="map my-4">
      <iframe title="Ahobala" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15469.518383317158!2d76.40988384387754!3d14.231064883533133!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x13dbf68c382eb477!2sSri%20Ahobala%20TVS!5e0!3m2!1sen!2sin!4v1642260983744!5m2!1sen!2sin" width="100%" height="400" allowfullscreen="" loading="lazy" className="iframe" ></iframe>
    </div>
  );
}